import React from 'react'
import SimpleBar from 'simplebar-react'
import VisibilitySensor from 'react-visibility-sensor'

import imagePreloader from './i/preloader.gif'

import './Templates.scss'

export default ({
    title = null,
    list = [],
    onAdd = () => {
        /**/
    },
    block = null,
    methods = {},
    canLoadMore = false,
    isLoading = false,
}) => {
    if (isLoading) {
        return (
            <div className="templates">
                <div className="templates__content">
                    {title && <p className="title">{title}</p>}
                    <div className="loader">
                        <img src={imagePreloader} alt="" />
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="templates">
            <SimpleBar autoHide={false}>
                <div className="templates__content">
                    {title && <p className="title">{title}</p>}
                    {list.length ? (
                        <ul className="templates__list">
                            {list.map(template => {
                                return (
                                    <li key={template.id} onClick={() => onAdd(block, template.structureJson)}>
                                        <div className="preview">
                                            <img src={template.imageUrl} alt="image" />
                                        </div>
                                        <div className="label">
                                            <span className="name">{template.name}</span>
                                            {template.description ? (
                                                <span className="description">{template.description}</span>
                                            ) : null}
                                        </div>
                                    </li>
                                )
                            })}
                        </ul>
                    ) : (
                        <div className="empty">Templates not found</div>
                    )}
                    {canLoadMore && !isLoading ? (
                        <VisibilitySensor onChange={isVisible => isVisible && methods.loadMore()}>
                            <div className="visibility-checker" />
                        </VisibilitySensor>
                    ) : null}
                </div>
            </SimpleBar>
        </div>
    )
}
